import { render, staticRenderFns } from "./BasicIbanInput.vue?vue&type=template&id=2e48b0f6&"
import script from "./BasicIbanInput.vue?vue&type=script&lang=js&"
export * from "./BasicIbanInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports